import { render, staticRenderFns } from "./GallerySection.vue?vue&type=template&id=62c6ff06&scoped=true"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"
import style0 from "./GallerySection.vue?vue&type=style&index=0&id=62c6ff06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c6ff06",
  null
  
)

export default component.exports